import React, { ReactNode } from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faExclamationTriangle,
  faSpinner,
} from '@fortawesome/pro-solid-svg-icons'
import Button from 'design-system/button'
import { ButtonSizes, ButtonVariant } from 'design-system/button/src/Button'
import ButtonProps from 'design-system/button/src/resources/ButtonProps.interface'
import styles from './ConfirmationModal.module.scss'

interface IConfirmationModal {
  show: boolean
  title?: string
  text: string
  acceptButtonText: ReactNode
  onAccept?: any
  onClose: any
  size?: 'sm' | 'lg' | 'xl'
  backdropClassName?: string
  acceptButtonProps?: Partial<ButtonProps>
  cancelButtonProps?: Partial<ButtonProps>
  loading?: boolean
}

const ConfirmationModal: React.FC<IConfirmationModal> = ({
  show,
  title = '',
  text,
  acceptButtonText,
  onAccept,
  onClose,
  size,
  backdropClassName,
  acceptButtonProps,
  cancelButtonProps,
  loading,
}) => {
  const { t } = useTranslation()

  return (
    <Modal
      show={show}
      size={size || 'lg'}
      centered
      className={styles.modalContainer}
      onHide={onClose}
      backdropClassName={backdropClassName}
    >
      <Modal.Header
        translate="yes"
        closeButton
        className={`${styles.warningModalHeader} d-flex align-items-center`}
      >
        <FontAwesomeIcon icon={faExclamationTriangle} />
        <h1 className="title">
          {title || t('components.modal.titles.warning')}
        </h1>
      </Modal.Header>
      <Modal.Body className="px-4 py-4">
        <div className={styles.text}>{text}</div>
      </Modal.Body>
      <div className="px-4 d-flex justify-content-center">
        <div className="dropdown-divider m-0 w-100 " />
      </div>
      <Modal.Footer className="border-0">
        <Button
          size={ButtonSizes.Small}
          variant={ButtonVariant.Secondary}
          className="my-0"
          onClick={onClose}
          disabled={loading}
          {...cancelButtonProps}
        >
          {t('components.modal.buttons.cancel')}
        </Button>
        <Button
          size={ButtonSizes.Small}
          variant={ButtonVariant.Primary}
          className="my-0"
          onClick={onAccept}
          disabled={loading}
          {...acceptButtonProps}
        >
          {loading && (
            <FontAwesomeIcon icon={faSpinner} spin className="mr-1" />
          )}
          {acceptButtonText}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ConfirmationModal
